module.exports = __webpack_public_path__ + "static/media/Dalgas_logo_RGB_reduced_padding.5c766d66.png";